export default __webpack_public_path__ + "static/media/avoidScam.0245493f.jpg";